angular
    .module('webcomm').filter('activeChannels', function() {
        return function(input) {
            var out = {};

            angular.forEach(input, (value, key) => {
                if (value && value.hasOwnProperty('active') && value.active)
                    out[key] = value;
            });

            return out;
        }
    });